<div class="section-title">
  <slot />
</div>

<style>
  .section-title {
    color: #aaaaaa;
  }
</style>
